export default __webpack_public_path__ + "static/33F324_6_0-e7dde1538c3ec57f952e20475c3297ad.woff2";